import { mapShipFromToProductWarehouse } from '../../products/product-details/mapping-helpers';
import Global from '../global-selectors';

export const patchProductEntitiesWithProductWarehouseUpdates = (state, productIds, warehouseIdsToAdd, warehouseIdsToDelete) => {
  const productEntities = Global.selectEntitiesProductsByIds(state, {
    productIds,
  });

  const patchedEntities = productEntities.map((ent) => {
    let newAssociations = ent.productWarehouses;

    if (warehouseIdsToAdd.length > 0) {
      const sellerShipFroms = Global.selectSellerShipFroms(state);
      const productWarehousesForAdding = sellerShipFroms.map((sf) =>
        mapShipFromToProductWarehouse(sf, [...new Set(ent.productWarehouses)]),
      );
      newAssociations = productWarehousesForAdding.map((productWarehouse) => {
        warehouseIdsToAdd.some((warehouse) => {
          if (productWarehouse.warehouseId.toString() === warehouse.toString()) {
            // oxlint-disable-next-line no-param-reassign
            productWarehouse.isSelected = true;
            return true;
          }

          return false;
        });

        return productWarehouse;
      });
    }

    if (warehouseIdsToDelete.length > 0) {
      const productWarehousesForDeleting = [...new Set(newAssociations)];
      newAssociations = productWarehousesForDeleting.map((productWarehouse) => {
        warehouseIdsToDelete.some((warehouse) => {
          if (productWarehouse.warehouseId.toString() === warehouse.toString()) {
            // oxlint-disable-next-line no-param-reassign
            productWarehouse.isSelected = false;
            return true;
          }

          return false;
        });

        return productWarehouse;
      });
    }

    return { ...ent, productWarehouses: [...newAssociations] };
  });

  return patchedEntities;
};
